module.exports = __webpack_public_path__ + "img/sem-foto.2751a49d.png";